module.exports = __webpack_public_path__ + "static/media/proposition_3.138a4184.svg";